import { createLucideIcon } from 'lucide-react';

// The glyph is a knockout in the disc, so it shows the surface behind the icon. A
// white disc below the coloured one fills the knockout with a fixed white. Its
// radius is 1 less, so no pale edge shows around the rim.

export const CircleXSolid = createLucideIcon('CircleXSolid', [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      fill: '#fff',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      d: 'M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0M7.24 7.24c.46-.46 1.2-.46 1.66 0l3.1 3.1 3.1-3.1a1.18 1.18 0 1 1 1.66 1.66l-3.1 3.1 3.1 3.1a1.18 1.18 0 1 1-1.66 1.66l-3.1-3.1-3.1 3.1a1.18 1.18 0 1 1-1.66-1.66l3.1-3.1-3.1-3.1a1.2 1.2 0 0 1 0-1.66',
      fill: 'currentColor',
      fillRule: 'evenodd',
      stroke: 'none',
    },
  ],
]);
